// extracted by mini-css-extract-plugin
export default {"color-HB-blue-principal":"#4a6f96","color-HB-blue-light":"#6286ac","color-HB-blue-strong":"#224d7c","inputGoogle":"Google_inputGoogle__y0FdG"};